// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"95f5a292","613":"67947e86","698":"d898c08c","739":"e6eae61b","843":"fc42c929"}[chunkId] + ".chunk.css";
};